import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { HomeIcon } from './icons';
export function MapSection() {
  return <section id="ubicacion" className="py-24 bg-brand-bg-dark" data-id="element-168">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-169">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-170">
          <div className="flex items-center justify-center gap-4 mb-12" data-id="element-171">
            <HomeIcon className="w-10 h-10 text-brand-gold" data-id="element-172" />
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-heading font-bold text-white text-center" data-id="element-173">
              Nuestra Ubicación
            </h2>
          </div>

          <p className="text-xl text-gray-400 text-center mb-10 max-w-2xl mx-auto" data-id="element-174">
            Ubicados en{' '}
            <span className="text-brand-gold font-bold" data-id="element-175">
              New Carrollton / Hyattsville, MD
            </span>{' '}
            — Sirviendo toda la región de Maryland, Washington DC y Virginia.
          </p>

          <div className="rounded-2xl overflow-hidden border-2 border-brand-gold/20 shadow-2xl" data-id="element-176">
            <iframe title="Ubicación de Benitez Handyman Construction - New Carrollton, MD" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d24869.04!2d-76.8819!3d38.9698!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89b7c14e3e3f4c27%3A0x7e5b5f7e5c5b5e5e!2sNew%20Carrollton%2C%20MD!5e0!3m2!1sen!2sus!4v1700000000000!5m2!1sen!2sus" width="100%" height="450" style={{
            border: 0
          }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" className="w-full" data-id="element-177"></iframe>
          </div>

          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-6 text-lg text-gray-400" data-id="element-178">
            <span className="flex items-center gap-2" data-id="element-179">
              <span className="w-3 h-3 bg-brand-gold rounded-full" data-id="element-180"></span>
              MD • DC • VA
            </span>
            <span className="hidden sm:block text-gray-700" data-id="element-181">|</span>
            <span data-id="element-182">Disponible 24/7 para toda la región</span>
          </div>
        </motion.div>
      </div>
    </section>;
}